/* src/app/modules/shared/red-asterisk/red-asterisk.component.scss */
/*# sourceMappingURL=red-asterisk.component-LJYU4SJD.css.map */
